module.exports = __webpack_public_path__ + "static/img/br_head_ok.fb845df2.webp";